import {
  Directive,
  HostListener,
  TemplateRef,
  inject,
  input,
  output
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { BaseDialogButton, BaseDialogComponent } from '../dialogs/base-dialog/base-dialog.component';

@Directive({
  selector: '[appOpenInModal]'
})
export class OpenInModalDirective {
  private dialog = inject(MatDialog);

  template = input.required<TemplateRef<any>>({alias: 'appOpenInModal'});

  modalTitle = input<string>();
  
  modalContext? = input<any>();
  
  modalConfig = input<any>({});

  modalFooterButtons = input<BaseDialogButton[]>([
    { label: 'Cancelar', action: 'close' },
    { label: 'Guardar', action: 'submit', color: 'primary' }
  ]);
  
  modalResult = output<any>();

  @HostListener('click')
  openModal() {
    const dialogRef = this.dialog.open(BaseDialogComponent, {
      ...this.modalConfig(),
      data: {
        title: this.modalTitle(),
        context: this.modalContext(),
        template: this.template(),
        buttons: this.modalFooterButtons(),
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result !== undefined) {
        this.modalResult.emit(result);
      }
    });
  }
}